module.exports = __webpack_public_path__ + "img/ani_test_atlas_P_5.67b93aa8.png";